import React from 'react';
import cx from 'classnames';
import useBuildVariantProps from '../../../../modules/theme/useBuildVariantProps';
import styles from './TableBody.module.scss';
import type { TableBodyProps } from './TableBody.types';

const TableBody = (props: TableBodyProps) => {
  const {
    className,
    children,
    ...otherProps
  } = props;

  const variantProps = useBuildVariantProps(
    'table',
    {},
    {},
  );

  return (
    <tbody className={cx(styles.tableBody, className)} { ...otherProps } { ...variantProps }>
      {children}
    </tbody>
  );
};
export default TableBody;
